import {PipelineSelectorProps, pipelinesSelector, useGetAllPipelinesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BasePipelineSelect, BasePipelineSelectProps} from "./BasePipelineSelect";

type Props = Omit<BasePipelineSelectProps, "entities" | "loading"> & {
    selector?: PipelineSelectorProps
}

export const PipelineSelect = (props: Props) => {
    const {selector, ...rest} = props;

    const selectPipelines = useMemo(() => {
        return pipelinesSelector()
    }, [])

    const {pipelines, isLoading} = useGetAllPipelinesQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            pipelines: selectPipelines(result, selector),
            isLoading: result.isLoading,
        })
    });

    return <BasePipelineSelect entities={pipelines} loading={isLoading} {...rest} />;
};
